var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDisappearingPhotos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "238px",
    height: "138px",
    viewBox: "0 0 238 138",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDisappearingPhotos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-username-popup---Learn-more",
    transform: "translate(-62.000000, -132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(62.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icDisappearingPhotos",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "49-491394_png-file-svg-alarm-clock-icon-png-clipartver2",
    transform: "translate(97.000000, 48.000000)",
    fill: "#7BCB45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7315358,29.96483 C54.7526377,37.0550996 52.6565064,42.6049238 48.7033998,47.4865182 C48.4923798,47.7538101 48.2883939,48.028136 48.049238,48.2672919 C47.8030481,48.5275498 47.7819461,48.7385698 47.971864,49.0621336 C48.7033998,50.3423212 49.4349355,51.6295428 50.1031653,52.9449004 C50.7502931,54.2110199 51.2778429,55.5263775 51.5240328,56.940211 C51.5943728,57.3481829 51.6154748,57.7842907 51.5662368,58.1992966 C51.4396249,59.3810082 50.6025791,60.028136 49.4138335,59.901524 C48.3305979,59.7819461 47.3247362,59.4021102 46.4314185,58.8182884 C44.6940211,57.7069168 43.0058617,56.5252052 41.3036342,55.3645955 C40.9449004,55.1184056 40.5932005,54.8651817 40.2555686,54.5908558 C40.0445487,54.4150059 39.8616647,54.4150059 39.6225088,54.5275498 C37.4701055,55.5193435 35.2332943,56.2508792 32.898007,56.6236811 C28.6072685,57.2989449 24.3657679,57.094959 20.2368113,55.6670574 C19.2942556,55.3434936 18.3728019,54.9636577 17.4654162,54.5627198 C17.0996483,54.4009379 16.8675264,54.4501758 16.5580305,54.6682298 C14.7995311,55.9202814 13.0480657,57.1723329 11.2473623,58.3610785 C10.1852286,59.0644783 9.04572098,59.6694021 7.75849941,59.887456 C6.32356389,60.133646 5.35287222,59.3247362 5.32473623,57.8616647 C5.30363423,56.7502931 5.62016413,55.7092614 6.02813599,54.6893318 C6.79484174,52.7690504 7.7866354,50.961313 8.87690504,49.2098476 C9.21453693,48.6682298 9.22860492,48.6471278 8.79953107,48.147714 C7.35052755,46.4454865 6.06330598,44.6307151 5.05744431,42.6330598 C2.79953107,38.1453693 1.7866354,33.3974209 2.32121923,28.3962485 C3.3059789,19.1676436 7.87807737,12.2321219 15.9460727,7.63188746 C18.8862837,5.95779601 22.0797186,4.99413834 25.4349355,4.64243845 C33.3200469,3.81242673 40.2626026,6.014068 46.1570926,11.3177022 C50.5674091,15.2778429 53.2614302,20.2579132 54.3446659,26.0820633 C54.6330598,27.6084408 54.6541618,29.1770223 54.7315358,29.96483 Z M50.2719812,30.9073857 C50.1735053,29.6201641 50.1453693,28.3259086 49.9695193,27.052755 C49.5896835,24.3235639 48.5556858,21.8053927 47.1277843,19.4701055 C42.7456038,12.2813599 34.6846424,7.8077374 24.9706917,9.20750293 C21.5310668,9.69988277 18.3868699,11.0644783 15.6084408,13.1676436 C10.1430246,17.3177022 7.05509965,22.8042204 6.71043376,29.6834701 C6.41500586,35.5779601 8.27198124,40.8042204 12.2110199,45.2145369 C16.2415006,49.7233294 21.3341149,52.1219226 27.3552169,52.5228605 C30.6260258,52.7409144 33.7631887,52.1078546 36.7948417,50.869871 C45.5732708,47.2895662 50.4830012,38.5322392 50.2719812,30.9073857 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: "3M",
    fontFamily: "Muli-Bold, Muli",
    fontSize: 20,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 14,
    y: 37
  }, "3M")), /*#__PURE__*/React.createElement("path", {
    d: "M40.6283705,4.12192263 C40.7198124,3.98124267 40.7831184,3.85463072 40.8745604,3.75615475 C41.7256741,2.84876905 42.5556858,1.92731536 43.4349355,1.05509965 C44.5603751,-0.0633059789 45.9179367,-0.225087925 47.3739742,0.267291911 C47.6975381,0.379835873 48.014068,0.56975381 48.2743259,0.794841735 C50.5252052,2.75732708 52.7971864,4.69871043 54.9988277,6.71746776 C56.4689332,8.06096131 56.6588511,10.0797186 55.4771395,11.6834701 C54.6119578,12.8581477 53.6201641,13.9343494 52.6494725,15.094959 C49.5545135,10.3610785 45.6858148,6.6049238 40.6283705,4.12192263 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6787808,4.11488863 C10.5791325,6.56271981 6.74560375,10.3610785 3.67878077,15.010551 C3.63657679,14.989449 3.5873388,14.982415 3.55920281,14.947245 C2.67291911,13.9202814 1.76553341,12.9073857 0.907385698,11.85932 C0.316529894,11.1348183 -0.0351699883,10.2907386 0.0633059789,9.32004689 C0.168815944,8.32121923 0.471277843,7.40679953 1.26611958,6.71043376 C3.45369285,4.78311841 5.62719812,2.84173505 7.8007034,0.893317702 C9.20046893,-0.35873388 11.6271981,-0.260257913 12.8511137,1.06916764 C13.6740914,1.96248535 14.5322392,2.82766706 15.3763189,3.71395076 C15.4677608,3.80539273 15.5381008,3.92497069 15.6787808,4.11488863 Z",
    id: "Path",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.714327,110 L177.285757,110 C176.023466,110 175,111.023401 175,112.285692 L175,135.714374 C175,136.976599 176.023466,138 177.285757,138 L208.714327,138 C209.976683,138 211.000149,136.976599 211.000149,135.714308 L211.000149,112.285692 C211.000149,111.023401 209.976748,110 208.714327,110 Z M208.714327,112.285692 L208.714327,128.909129 L204.209741,124.813695 C203.532681,124.198268 202.491502,124.222844 201.844638,124.870296 L197.285673,129.428542 L188.296632,118.691393 C187.617154,117.879953 186.372576,117.871979 185.682901,118.67368 L177.285757,128.432592 L177.285757,112.285692 L208.714327,112.285692 Z M199.000121,118.285706 C199.000121,116.549688 200.406857,115.142822 202.142874,115.142822 C203.878956,115.142822 205.285757,116.549688 205.285757,118.285706 C205.285757,120.021723 203.879022,121.428523 202.142874,121.428523 C200.406922,121.428589 199.000121,120.021723 199.000121,118.285706 Z",
    id: "Shape",
    fill: "#7BCB45",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "quickMessage",
    opacity: 0.3,
    transform: "translate(27.000000, 99.000000)",
    stroke: "#7BCB45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33333333,13.0952381 C8.84954721,16.1385417 10.7604976,17.6349795 13.8477337,19.1196215 L13.8477337,24.6145119 C13.8477337,24.7556621 13.9319172,24.8866988 14.0670979,24.9538294 C14.1289036,24.9847564 14.1971029,25 14.2648455,25 C14.3447665,25 14.4248398,24.9784537 14.4941047,24.936094 L21.1720033,20.8512397 C21.4422126,20.8642848 21.6950676,20.8774764 21.9526417,20.8774764 C29.7984533,20.8774764 35.7142857,16.3898384 35.7142857,10.4391046 C35.7142857,4.487638 29.7984533,0 21.9526417,0 C18.0299643,0 14.5897055,1.12187286 12.1299639,2.98775233 L18.0998381,2.98775233 L12.5,13.0952381 L8.33333333,13.0952381 Z",
    id: "Stroke-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57142857,5.95238095 L14.2857143,5.95238095",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8.33333333 L10.7142857,8.33333333",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57142857,10.7142857 L9.52380952,10.7142857",
    id: "Stroke-9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    fill: "#FFFFFF",
    cx: 19.047619,
    cy: 10.7142857,
    r: 1.19047619
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    fill: "#FFFFFF",
    cx: 23.8095238,
    cy: 10.7142857,
    r: 1.19047619
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    fill: "#FFFFFF",
    cx: 28.5714286,
    cy: 10.7142857,
    r: 1.19047619
  })), /*#__PURE__*/React.createElement("g", {
    id: "quickMessage",
    opacity: 0.3,
    transform: "translate(59.000000, 9.000000)",
    stroke: "#7BCB45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333333,11.5238095 C7.78760155,14.2019167 9.46923791,15.5187819 12.1860056,16.8252669 L12.1860056,21.6607705 C12.1860056,21.7849827 12.2600871,21.9002949 12.3790462,21.9593699 C12.4334351,21.9865856 12.4934505,22 12.553064,22 C12.6233945,22 12.693859,21.9810393 12.7548121,21.9437627 L18.6313629,18.349091 C18.8691471,18.3605706 19.0916595,18.3721792 19.3183247,18.3721792 C26.2226389,18.3721792 31.4285714,14.4230578 31.4285714,9.18641206 C31.4285714,3.94912144 26.2226389,0 19.3183247,0 C15.8663686,0 12.8389408,0.987248114 10.6743682,2.62922205 L15.9278575,2.62922205 L11,11.5238095 L7.33333333,11.5238095 Z",
    id: "Stroke-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14285714,5.23809524 L12.5714286,5.23809524",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.33333333 L9.42857143,7.33333333",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14285714,9.42857143 L8.38095238,9.42857143",
    id: "Stroke-9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    fill: "#FFFFFF",
    cx: 16.7619048,
    cy: 9.42857143,
    r: 1.04761905
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    fill: "#FFFFFF",
    cx: 20.952381,
    cy: 9.42857143,
    r: 1.04761905
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    fill: "#FFFFFF",
    cx: 25.1428571,
    cy: 9.42857143,
    r: 1.04761905
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.4898284,42 L1.7959519,42 C0.804152204,42 6.5192296e-13,42.8041008 6.5192296e-13,43.7959006 L6.5192296e-13,62.2041508 C6.5192296e-13,63.1958992 0.804152204,64 1.7959519,64 L26.4898284,64 C27.4816795,64 28.2858317,63.1958992 28.2858317,62.2040994 L28.2858317,43.7959006 C28.2858317,42.8041008 27.4817308,42 26.4898284,42 Z M26.4898284,43.7959006 L26.4898284,56.8571729 L22.9505111,53.6393316 C22.4185351,53.1557823 21.6004659,53.1750914 21.0922154,53.6838041 L17.5101716,57.2652831 L10.447354,48.8289515 C9.91347786,48.1913917 8.93559509,48.1851265 8.39370774,48.8150346 L1.7959519,56.4827509 L1.7959519,43.7959006 L26.4898284,43.7959006 Z M18.8572382,48.5101973 C18.8572382,47.1461838 19.9625303,46.0407891 21.3265437,46.0407891 C22.6906085,46.0407891 23.7959519,47.1461838 23.7959519,48.5101973 C23.7959519,49.8742107 22.6906599,50.9795541 21.3265437,50.9795541 C19.9625816,50.9796055 18.8572382,49.8742107 18.8572382,48.5101973 Z",
    id: "Shape",
    fill: "#7BCB45",
    fillRule: "nonzero",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.061247,0 L155.224513,0 C154.548286,0 154,0.548250579 154,1.22447765 L154,13.7755574 C154,14.4517494 154.548286,15 155.224513,15 L172.061247,15 C172.737509,15 173.285794,14.4517494 173.285794,13.7755224 L173.285794,1.22447765 C173.285794,0.548250579 172.737544,0 172.061247,0 Z M172.061247,1.22447765 L172.061247,10.1298906 L169.648076,7.93590788 C169.285365,7.60621523 168.72759,7.61938053 168.381056,7.96623008 L165.938753,10.4081475 L161.123196,4.65610331 C160.759189,4.22140341 160.092451,4.21713169 159.722983,4.64661449 L155.224513,9.87460288 L155.224513,1.22447765 L172.061247,1.22447765 Z M166.857208,4.43877087 C166.857208,3.50876169 167.610816,2.75508346 168.540825,2.75508346 C169.470869,2.75508346 170.224513,3.50876169 170.224513,4.43877087 C170.224513,5.36878004 169.470904,6.12242325 168.540825,6.12242325 C167.610851,6.12245827 166.857208,5.36878004 166.857208,4.43877087 Z",
    id: "Shape",
    fill: "#7BCB45",
    fillRule: "nonzero",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "quickMessage",
    opacity: 0.28,
    transform: "translate(208.000000, 46.000000)",
    stroke: "#7BCB45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,10.4761905 C7.07963777,12.9108334 8.6083981,14.1079836 11.0781869,15.2956972 L11.0781869,19.6916096 C11.0781869,19.8045297 11.1455338,19.909359 11.2536784,19.9630635 C11.3031228,19.9878051 11.3576823,20 11.4118764,20 C11.4758132,20 11.5398718,19.982763 11.5952838,19.9488752 L16.9376027,16.6809918 C17.1537701,16.6914278 17.3560541,16.7019811 17.5621134,16.7019811 C23.8387627,16.7019811 28.5714286,13.1118707 28.5714286,8.35128369 C28.5714286,3.5901104 23.8387627,0 17.5621134,0 C14.4239714,0 11.6717644,0.897498285 9.7039711,2.39020186 L14.4798705,2.39020186 L10,10.4761905 L6.66666667,10.4761905 Z",
    id: "Stroke-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85714286,4.76190476 L11.4285714,4.76190476",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.66666667 L8.57142857,6.66666667",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85714286,8.57142857 L7.61904762,8.57142857",
    id: "Stroke-9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    fill: "#FFFFFF",
    cx: 15.2380952,
    cy: 8.57142857,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    fill: "#FFFFFF",
    cx: 19.047619,
    cy: 8.57142857,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    fill: "#FFFFFF",
    cx: 22.8571429,
    cy: 8.57142857,
    r: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDisappearingPhotos);
export default __webpack_public_path__ + "static/media/icDisappearingPhotos.40336cac2326f3a24dd428a8b2bf356e.svg";
export { ForwardRef as ReactComponent };